import React from 'react';
export function FAQSection() {
  const faqs = [{
    q: '¿Necesito experiencia previa?',
    a: 'No. Está pensada para acompañarte desde cero.'
  }, {
    q: '¿Es solo teoría?',
    a: 'No. Incluye situaciones reales y qué hacer en cada una.'
  }, {
    q: '¿En qué formato se entrega?',
    a: 'PDF descargable con acceso inmediato.'
  }];
  return <section className="w-full bg-white py-24 md:py-32 px-6" data-id="element-73">
      <div className="max-w-2xl mx-auto" data-id="element-74">
        <div className="space-y-12" data-id="element-75">
          {faqs.map((faq, index) => <div key={index} className="text-center md:text-left" data-id="element-76">
              <h4 className="font-serif text-xl md:text-2xl text-charcoal-700 mb-3 uppercase tracking-wide" data-id="element-77">
                {faq.q}
              </h4>
              <p className="text-charcoal-400 font-light text-lg" data-id="element-78">{faq.a}</p>
            </div>)}
        </div>
      </div>
    </section>;
}